import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import Warning from '@mui/icons-material/Warning';
import { MailProDialog } from 'views/Pma/MailPro/components/MailProDialog/MailProDialog';
import { MailProDialogHeader } from 'views/Pma/MailPro/components/MailProDialog/MailProDialogHeader';
import { MailProDialogBody } from 'views/Pma/MailPro/components/MailProDialog/MailProDialogBody';
import { handleLogoutFn } from 'common/helpers';


// Simple styles for content
const styles = {
  warningIcon: {
    fontSize: '48px',
    color: '#e74c3c',
    marginRight: '8px',
  },
  loginButton: {
    backgroundColor: '#4A7396',
    color: 'white',
    borderRadius: '4px',
    padding: '12px 32px',
    fontSize: '16px',
    fontWeight: 500,
    textTransform: 'none',
    fontFamily: 'objektiv-mk2',
    '&:hover': {
      backgroundColor: '#6B7B85',
    },
  },
  contentContainer: {
    textAlign: 'center',
    padding: '24px',
  },
};

const SessionExpirationDialog = ({ open, onClose, onSessionExpired }) => {
  const handlePrimaryAction = () => {
    if (onSessionExpired) {
      onSessionExpired();
      return;
    }

    // Fallback behavior if no callback is supplied.
    handleLogoutFn(1);
  };

  const handleDialogClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <MailProDialog
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown
    >
      <MailProDialogHeader>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Warning style={{...styles.warningIcon, color: 'white'}} />
          <Typography variant="h5" style={{color: 'white'}}>
            Session Expired
          </Typography>
        </Box>
      </MailProDialogHeader>
      
      <MailProDialogBody>
        <div style={styles.contentContainer}>
          <Typography 
            variant="body1" 
            style={{ fontWeight: 500, fontSize: '18px', color: '#333' }}
            dangerouslySetInnerHTML={{
              __html: 'Your session has expired for security reasons.<br/>Please log in again to continue.'
            }}
          />
          
          <div style={{ marginTop: '24px' }}>
            <Button
              onClick={handlePrimaryAction}
              style={styles.loginButton}
              variant="contained"
              size="large"
            >
              Login Again
            </Button>
          </div>
        </div>
      </MailProDialogBody>
    </MailProDialog>
  );
};

export default SessionExpirationDialog;
